import axios from 'axios'
class Errors {
  /**
   * Create a new Errors instance.
   */
  constructor () {
    this.errors = {}
  }

  /**
   * Determine if an errors exists for the given field.
   *
   * @param {string} field
   */
  has (field) {
    // eslint-disable-next-line no-prototype-builtins
    var hasFieldProperty = this.errors.hasOwnProperty(field)
    return hasFieldProperty
  }

  /**
   * Determine if we have any errors.
   */
  any () {
    return Object.keys(this.errors).length > 0
  }

  /**
   * Retrieve the error message for a field.
   *
   * @param {string} field
   */
  get (field) {
    if (this.errors[field]) {
      // return this.errors[field][0]
      return this.errors[field]
    }
  }

  /**
   * Record the new errors.
   *
   * @param {object} errors
   */
  record (errors) {
    this.errors = errors
  }

  /**
   * Clear one or all error fields.
   *
   * @param {string|null} field
   */
  clear (field) {
    if (field) {
      delete this.errors[field]

      return
    }

    this.errors = {}
  }
  //   end of error class
}
class Form {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   */
  constructor (data) {
    this.originalData = data

    for (const field in data) {
      this[field] = data[field]
    }

    this.errors = new Errors()
  }

  /**
   * Fetch all relevant data for the form.
   */
  data () {
    const data = {}

    for (const property in this.originalData) {
      data[property] = this[property]
    }

    return data
  }

  /**
   * Reset the form fields.
   */
  reset () {
    for (const field in this.originalData) {
      this[field] = ''
    }

    this.errors.clear()
  }

  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   */
  post (url, thankyouUrl) {
    return this.submit('post', url, thankyouUrl)
  }

  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   */
  put (url) {
    return this.submit('put', url)
  }

  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   */
  patch (url) {
    return this.submit('patch', url)
  }

  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   */
  delete (url) {
    return this.submit('delete', url)
  }

  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess (data, thankyouUrl) {
    if (data.status === '404' | data.error) {
      this.onFail(data.errors)
      console.log('error')
    } else {
      // console.log(data)
      // console.log(data.zahlungsmethode)
      // Simulate an HTTP redirect:
      // console.log(data.paymentMade)
      if (data.message === 'MESSAGE_SENT') {
        this.reset()
        window.location.replace(thankyouUrl)
      } else {
        console.log(data)
      }
      // self.$router.push(
      //   {
      //     name: 'thankyou',
      //     params: { slug: 'thankyou' }
      //   })
    }
  }

  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail (errors) {
    // console.log(errors)
    this.errors.record(errors)
  }

  /**
   * Submit the form.
   *
    * @param {*} requestType
    * @param {*} url
    * @param {*} thankyouUrl
   */

  submit (requestType, url, thankyouUrl = '') {
    return new Promise((resolve, reject) => {
      axios[requestType](url, this.data())
        .then(response => {
          this.onSuccess(response.data, thankyouUrl)
          resolve(response.data)
        })
        .catch(error => {
          console.log('error')
          console.log(error)
          this.onFail(error.response.data.errors)
          reject(error.response.data.errors)
        })
    })
  }
}

export default Form
